import { Button, Col, Form, Input, notification, Row, Select, Table } from "antd";
import SlipModalComponent from "components/SlipModalComponent";
import { DOCUMENT_TYPE_ID } from "constants";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { copyPhieuNhapThueSangNoiBo } from "store/slices/sale/nhapxuatSlice";
import { getXuatKhoCTByManx } from "store/slices/sale/xuatkhoSlice";
import Utils from "utils";

const ModelCopyPhieuXuat = ({
    isVisibleCopy,
    setIsVisibleCopy,
    record
}) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { dmKkList } = useSelector((state) => state.danhMucSale);
    const { xuatKhoCTList } = useSelector((state) => state.xuatKhoSale);

    const childRef = useRef(null);

    const onFinish = (values) => {
        try {
            const payload = {
                tuManx: record?.manx,
                denMakk: values?.denMakk,
                ...values,
                onSuccess: ({ data }) => {
                    if (data.data.Id && data.data.MaPhieu && childRef.current) {
                        childRef.current.signedDocumentCreate(
                            data.data.Id,
                            data.data.MaPhieu
                        );

                        notification.info({ message: "Thông báo", description: `Đã sao chép sang số phiếu <${data.data.MaPhieu}>` })
                    }
                },
            };

            dispatch(copyPhieuNhapThueSangNoiBo(payload));
        } catch (error) { }
    };

    useEffect(() => {
        dispatch(
            getXuatKhoCTByManx({
                manx: record?.manx,
                isNewCt: false,
            })
        );
        form.setFieldValue("ghichu", record?.ghichu)
    }, [dispatch, form, record])

    const tableColumns = useMemo(
        () => [
            {
                title: "STT",
                width: 40,
                align: "center",
                dataIndex: "thuTu",
            },
            {
                title: "Mã số",
                width: 80,
                dataIndex: "maview",
                editable: true,
            },
            {
                title: "Tên thuốc, vật tư",
                width: 250,
                dataIndex: "tenhh",
                editable: true,
                render: (txt, record) => (record.tenhh
                ),
            },
            {
                title: "ĐVT",
                dataIndex: "tendonvitinh",
                width: 100,
                editable: true,
            },

            {
                title: "Số lượng",
                width: 80,
                dataIndex: "soluong",
                align: "right",
                editable: true,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Đơn giá",
                width: 80,
                dataIndex: "dongiachuyendoi",
                align: "right",
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Thành tiền",
                width: 90,
                dataIndex: "thanhtien",
                align: "right",
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [xuatKhoCTList]
    );

    const ChiTiet = () => {
        return <Table dataSource={xuatKhoCTList} columns={tableColumns} pagination={false}
            style={{ padding: "0px" }}
            rowClassName="editable-row"
            tableLayout="fixed"
            scroll={{ x: "max-content" }}
        />
    }
    return (
        <SlipModalComponent
            ref={childRef}
            maskClosable={false}
            bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 300px)" }}
            width={1400}
            title={"Sao chép phiếu xuất từ Thuế sang Nội bộ"}
            widthInfo={550}
            //objectId={importHoadonList?.hoaDonViewModel?.id}
            objectType={"PhieuXuatKho"}
            documentTypeId={DOCUMENT_TYPE_ID.XuatHang}
            titleTLink="Sao chép phiếu xuất từ Thuế sang Nội bộ"
            isVisibleModal={isVisibleCopy}
            onRenderTab={[
                {
                    label: "Thông tin chi tiết",
                    children: (
                        <ChiTiet />
                    ),
                },
            ]}
            onRenderInfo={() => <>
                <div className="p-3">
                    <Row gutter={24}>
                        <Col sm={24}><h4>Từ Số phiếu: {record.sophieu}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Ngày lập: {Utils.formatDate(record.ngay)}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Đơn vị giao: {(record.tenkkgiao)}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Đơn vị nhận: {(record.tenkknhan)}</h4></Col>
                    </Row>
                </div>
                <Form form={form} layout="vertical" onFinish={onFinish} className="p-3">
                    <Row gutter={24}>
                        <Col sm={24}>
                            <Form.Item
                                name="denMakk"
                                label="Đến kho"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng chọn kho",
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    //filterOption={filterOption}
                                    options={dmKkList?.filter((x) => x.maloai === 1 && x.isthue === true)}
                                    placeholder="Chọn kho nhập"
                                />
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={24}>
                        <Col sm={24}>
                            <Form.Item name="ghichu" label="Ghi chú">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col sm={24}>
                            <Button type="primary" onClick={() => form.submit()}>Lưu</Button>
                        </Col>
                    </Row>

                </Form></>}
            onCancelModal={() => {
                form.resetFields();
                setIsVisibleCopy(false)
            }}
        />
    );
};
export default ModelCopyPhieuXuat;
